import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
export default function Ceo() {
    const { t } = useTranslation();
    useScrollAnimation();
    return (
        <>
            <section className="landingpages">
                <div className="container h-full flex flex-col items-center justify-center text-center">
                    <div className="btmAni1256 text-[#017E89] font-bold text-[35px] capitalize">{t("CEO Message")}</div>
                    <div className="btmAni2000 flex items-center gap-[5px] fonbold">
                        <Link to={"/"}>{t("Home")}</Link>
                        -
                        <span className="text-[#017E89] capitalize">{t("CEO Message")}</span>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container flex flex-col justify-center items-center gap-[50px]">
                    <div className="btmAni25002">
                        <img className="w-[350px] h-auto rounded-[8px]" src={require("../../assets/image/dr.jpg")} alt="" />
                    </div>
                    <div className="w-[75%] text-center flex flex-col gap-[20px]">
                        <p className="js-scroll fade-btm text-[15px] font-mono italic">
                            {t("ceo text 1")}
                        </p>
                        <p className="js-scroll fade-btm text-[15px] font-mono italic">
                            {t("ceo text 2")}
                        </p>
                        <p className="js-scroll fade-btm text-[15px] font-mono italic">
                            {t("ceo text 3")}
                        </p>
                        <p className="js-scroll fade-btm text-[15px] font-mono italic">
                            {t("ceo text 4")}
                        </p>
                    </div>
                </div>
            </section>
            <section>
                <div className="container">
                    <div className="js-scroll fade-btm font-bold">{t("Founder & CEO")}</div>
                    <div className="js-scroll fade-btm font-bold">{t("Dr. Mohammed Al-Saleh")}</div>
                    <div className="js-scroll fade-btm">
                        <img className="w-[120px] h-[120px]" src={require("../../assets/image/sigtitsher.svg").default} alt="" />
                    </div>
                </div>
            </section>
        </>
    );
}